import { User } from "lucide-react";
import React from "react";

function MyCard2({ className = "", children, onClick, icon, title ,color=''}) {
  const Icon = icon || User;
 
  return (
    <div
      onClick={() => onClick && onClick()}
      className={`w-full   ${className}   flex flex-col rounded-lg bg-gray-400/13 dark:bg-slate-800 `}
    >
      <div className="flex items-start justify-start space-x-2">
        <Icon className={`w-[14px] h-[14px] ${color.text}  ${color=='' && "text-slate-500 dark:text-slate-300"} `} />
        <span className="text-[11px] font-normal font-sans  text-slate-500 dark:text-slate-300">
          {title}
        </span>
      </div>
      {children}
    </div>
  );
}
export default MyCard2;
